import React from "react";

export interface Props {
  linkHandler: any;
  linkContent: string;
  link: string;
}
const Link = (props: Props) => {
  return (
    <a
      href="#"
      onClick={() => {
        props.linkHandler(props.linkContent);
      }}
    >
      {props.link}
    </a>
  );
};

export default Link;
